/* src/app/modules_v2/booking/components/booking-reports/employees-report/employees-report.component.scss */
.informe-empleados .seccion-grafico {
  margin-bottom: 2rem;
}
.informe-empleados .seccion-grafico h3 {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #4d4e56;
}
.informe-empleados .seccion-grafico .contenedor-grafico {
  position: relative;
  height: 280px;
}
.informe-empleados .seccion-kpis {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.5rem;
  margin-bottom: 3rem;
}
.informe-empleados .seccion-kpis .tarjeta-kpi {
  background:
    linear-gradient(
      135deg,
      #6c3fb5 0%,
      #4a2a7f 100%);
  color: white;
  padding: 1.5rem;
  border-radius: 4px;
  text-align: center;
  box-shadow: 0 2px 8px rgba(108, 63, 181, 0.1);
  transition: transform 0.2s, box-shadow 0.2s;
}
.informe-empleados .seccion-kpis .tarjeta-kpi:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 12px rgba(108, 63, 181, 0.2);
}
.informe-empleados .seccion-kpis .tarjeta-kpi .etiqueta-kpi {
  font-size: 0.875rem;
  opacity: 0.9;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.informe-empleados .seccion-kpis .tarjeta-kpi .valor-kpi {
  font-size: 1.75rem;
  font-weight: 700;
  margin-bottom: 0.25rem;
}
.informe-empleados .seccion-kpis .tarjeta-kpi .unidad-kpi {
  font-size: 0.75rem;
  opacity: 0.8;
  text-transform: uppercase;
}
.informe-empleados .seccion-tabla {
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 1.5rem;
}
.informe-empleados .seccion-tabla h3 {
  margin: 0 0 1.5rem 0;
  color: #333;
  font-size: 1.1rem;
}
.informe-empleados .seccion-tabla .tabla-responsiva {
  overflow-x: auto;
}
.informe-empleados .seccion-tabla .tabla-informe {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
}
.informe-empleados .seccion-tabla .tabla-informe thead {
  background-color: #f5f5f5;
  border-bottom: 2px solid #ddd;
}
.informe-empleados .seccion-tabla .tabla-informe thead th {
  padding: 0.75rem;
  text-align: left;
  font-weight: 600;
  color: #333;
  text-transform: uppercase;
  font-size: 0.8rem;
  letter-spacing: 0.05em;
}
.informe-empleados .seccion-tabla .tabla-informe tbody tr {
  border-bottom: 1px solid #ddd;
  transition: background-color 0.2s;
}
.informe-empleados .seccion-tabla .tabla-informe tbody tr:hover {
  background-color: #f9f9f9;
}
.informe-empleados .seccion-tabla .tabla-informe tbody tr td {
  padding: 0.75rem;
  color: #333;
}
.informe-empleados .seccion-tabla .tabla-informe tbody tr td.texto-derecha {
  text-align: right;
  font-weight: 600;
}
.informe-empleados .seccion-tabla .tabla-informe tbody tr td .celda-ocupacion {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.informe-empleados .seccion-tabla .tabla-informe tbody tr td .celda-ocupacion .barra-ocupacion {
  flex: 0 0 80px;
  height: 18px;
  background-color: #e9ecef;
  border-radius: 2px;
  position: relative;
  overflow: hidden;
}
.informe-empleados .seccion-tabla .tabla-informe tbody tr td .celda-ocupacion .barra-ocupacion.ocupacion-high {
  background:
    linear-gradient(
      90deg,
      #28a745,
      #20c997);
}
.informe-empleados .seccion-tabla .tabla-informe tbody tr td .celda-ocupacion .barra-ocupacion.ocupacion-medium {
  background:
    linear-gradient(
      90deg,
      #ffc107,
      #fd7e14);
}
.informe-empleados .seccion-tabla .tabla-informe tbody tr td .celda-ocupacion .barra-ocupacion.ocupacion-low {
  background:
    linear-gradient(
      90deg,
      #6c757d,
      #495057);
}
.informe-empleados .seccion-tabla .tabla-informe tbody tr td .celda-ocupacion .texto-ocupacion {
  flex: 0 0 35px;
  text-align: right;
  font-weight: 600;
  font-size: 0.85rem;
}
.informe-empleados .seccion-tabla .sin-datos {
  text-align: center;
  color: #999;
  padding: 2rem;
  margin: 0;
}
@media (max-width: 768px) {
  .informe-empleados .seccion-kpis {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 1rem;
  }
  .informe-empleados .seccion-kpis .tarjeta-kpi {
    padding: 1rem;
  }
  .informe-empleados .seccion-kpis .tarjeta-kpi .valor-kpi {
    font-size: 1.25rem;
  }
  .informe-empleados .seccion-tabla {
    padding: 1rem;
  }
  .informe-empleados .seccion-tabla .tabla-informe {
    font-size: 0.8rem;
  }
  .informe-empleados .seccion-tabla .tabla-informe th,
  .informe-empleados .seccion-tabla .tabla-informe td {
    padding: 0.5rem;
  }
  .informe-empleados .seccion-tabla .tabla-informe td .celda-ocupacion {
    flex-direction: column;
    align-items: flex-start;
  }
  .informe-empleados .seccion-tabla .tabla-informe td .celda-ocupacion .barra-ocupacion {
    width: 100%;
  }
  .informe-empleados .seccion-tabla .tabla-informe td .celda-ocupacion .texto-ocupacion {
    width: 100%;
    text-align: left;
  }
}
/*# sourceMappingURL=employees-report.component.css.map */
